var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMindIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879",
    transform: "translate(-158 -118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3179",
    "data-name": "Group 3179",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 143",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(158 109)",
    fill: "#ffba7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(171.463 127.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365",
    transform: "translate(8.153 7.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M41.142,38.368a.664.664,0,0,1-.468-.2L33.5,30.987a5.33,5.33,0,1,1,7.537-7.537l.086.086.086-.086a5.363,5.363,0,0,1,3.774-1.533,5.48,5.48,0,0,1,3.805,1.531,5.337,5.337,0,0,1,0,7.539L41.61,38.164A.663.663,0,0,1,41.142,38.368ZM37.288,23.194a4.046,4.046,0,0,0-2.855,6.9l6.687,6.731L47.852,30.1a4.038,4.038,0,1,0-5.71-5.71l-.532.532a.638.638,0,0,1-.936,0l-.531-.532A4.017,4.017,0,0,0,37.288,23.194Z",
    transform: "translate(-31.938 -21.883)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M30.426,5.718c7.895,0,12.732,5.765,13.275,11.19a16.15,16.15,0,0,1-1.765,9.429,13.012,13.012,0,0,0-1.308,3.872c-.292,2.433.621,5.643,1.438,7.907a.287.287,0,0,1-.015.236.294.294,0,0,1-.187.151L27.256,42.511a.2.2,0,0,1-.057.008.214.214,0,0,1-.2-.153l-1.306-4.407a2.187,2.187,0,0,0-1.932-1.55l-3.327-.218a3.612,3.612,0,0,1-3.351-3.323l-.3-4.009a1.293,1.293,0,0,0-.711-1.061l-1.515-.758a.436.436,0,0,1-.2-.571l2.61-5.795a2.609,2.609,0,0,0,.248-1.105c.007-2.306.678-13.81,13.159-13.852h.054m0-1.293h-.059c-13.836.047-14.441,13.03-14.448,15.141a1.328,1.328,0,0,1-.13.568l-2.615,5.805a1.731,1.731,0,0,0,.8,2.258l1.515.758.3,4.009a4.888,4.888,0,0,0,4.555,4.517l3.327.219a.879.879,0,0,1,.777.626l1.305,4.407A1.5,1.5,0,0,0,27.6,43.758L42.207,39.75a1.59,1.59,0,0,0,1.077-2.073c-.682-1.89-1.642-5.057-1.371-7.314.41-3.417,3.828-6.076,3.076-13.584-.627-6.259-6.2-12.354-14.562-12.354Z",
    transform: "translate(-13.022 -4.425)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M48.088,53.812",
    transform: "translate(-32.975 -32.526)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M35.9,41.619",
    transform: "translate(-26.037 -25.588)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindIcon);
export default __webpack_public_path__ + "static/media/mindIcon.301a092d5b33a1fe35335fab59d89ae6.svg";
export { ForwardRef as ReactComponent };